export const BROWSER_ROUTES = {
	// Auth routes
	LOGIN: "/sign-in",
	SIGNUP: "/signup",
	SIGNUP_VERIFY_OTP: "/signup/verify-otp",
	SIGNUP_RESET_PASSWORD: "/signup/reset-password",
	// Profile form routes (accessible after login) - 2-step structure
	ADMISSION_FORM: "/profile",
	ADMISSION_BASIC_INFO: "/profile/basic-info",
	ADMISSION_QUALIFICATION: "/profile/qualification",
	// Legacy routes - redirect to new structure (for backward compatibility)
	ADMISSION_PERSONAL_INFO: "/profile/basic-info",
	ADMISSION_GUARDIAN_INFO: "/profile/basic-info",
	ADMISSION_CONTACT_INFO: "/profile/basic-info",
	ADMISSION_ADDRESS_INFO: "/profile/basic-info",
	// Profile routes (aliases for consistency)
	PROFILE: "/profile",
	PROFILE_BASIC_INFO: "/profile/basic-info",
	PROFILE_QUALIFICATION: "/profile/qualification",
	// Legacy profile routes - redirect to new structure
	PROFILE_PERSONAL_INFO: "/profile/basic-info",
	PROFILE_GUARDIAN_INFO: "/profile/basic-info",
	PROFILE_CONTACT_INFO: "/profile/basic-info",
	PROFILE_ADDRESS_INFO: "/profile/basic-info",
	VERIFY_EMAIL: "/verify-email",
	FORGET_PASSWORD: "/forget-password",
	REGISTRATION_RECOVERY: "/update-email",
	VERIFY_OTP: "/verify-otp",
	RESET_PASSWORD: "/reset-password",
	UNAUTHORIZED: "/unauthorized",
	SERVER_ERROR: "/500",
	NOT_FOUND: "/404",
	ABOUT: "/about",
	// Legal routes
	PRIVACY_POLICY: "/privacy-policy",
	TERMS_AND_CONDITIONS: "/terms-and-conditions",
	FAQ: "/faq",
	// Dashboard routes
	DASHBOARD: "/",
	// Application routes
	APPLICATIONS: "/applications",
	REVIEW_APPLICATIONS: "/review-applications",
	TRACK_APPLICATION: "/track-application",
	MY_COURSES: "/my-courses",
	MY_RESULTS: "/my-results",
	JOB: "/job",
	JOB_REQUESTS: "/job-requests",
	SHORTLISTED: "/shortlisted",
	SELECTED: "/selected",
	REGISTRATION: "/profile",
} as const;

export const REVIEW_APPLICATION_STEP_ROUTES = [
	["basic-info"],
	["qualification/matriculation", "qualification/intermidiate", "qualification/bachelor"],
];

export const EXTERNAL_LINKS = {
	LANDING_PORTAL: "https://tmis-skills.optimusfoxdev.com/",
} as const;